/**
 * The forecast marks (DESIGN §5): dashed means could change, solid means happened. `GxForecastPill` heads every card that shows preview figures; `forecastCardClass` is the dashed edge those cards carry.
 * The popover says what a forecast is here; the wider form names a basis that differs ("Forecast, worst quarter-end of the year").
 */
import { GxHint } from "./GxHint";
import "./forecast-marks.css";

export const FORECAST_POPOVER = "Projected on the published economic outlook. The year is played on the real economy and on your rivals’ moves, so the outcome will differ.";
export const FORECAST_NOTE = "Projected on the published outlook; the real year will differ.";
export const FORECAST_RANGE_POPOVER = "From the published low and high outlooks. It does not include surprises, cards or rivals.";
/** The class a card that shows preview figures carries: a dashed navy edge. */
export const FORECAST_CARD = "gx-card--forecast";

export function GxForecastPill({ basis, testId = "forecast.pill" }: { readonly basis?: string; readonly testId?: string }) {
  return (
    <GxHint text={FORECAST_POPOVER} label="What a forecast is" className="gx-fpill-wrap" testId={testId}>
      <span className="gx-fpill"><svg width="8" height="8" viewBox="0 0 8 8" aria-hidden="true" focusable="false"><circle cx="4" cy="4" r="3.2" fill="none" stroke="currentColor" strokeWidth="1.2" strokeDasharray="2 1.6" /></svg>{basis === undefined ? "Forecast" : `Forecast, ${basis}`}</span>
    </GxHint>
  );
}
